// https://codesandbox.io/s/z33rnoy1nm
function focusAndOpenKeyboard(el, timeout) {
  if (!timeout) {
    timeout = 100;
  }
  if (el) {
    // Align temp input element approx. to be where the input element is
    const tempEl = document.createElement('input');
    tempEl.style.position = 'absolute';
    tempEl.style.top = el.offsetTop + 7 + 'px';
    tempEl.style.left = el.offsetLeft + 'px';
    tempEl.style.height = '0px';
    tempEl.style.opacity = '0';
    // Put this temp element as a child of the page <body> and focus on it
    document.body.appendChild(tempEl);
    tempEl.focus();

    // The keyboard is open. Now do a delayed focus on the target element
    setTimeout(function () {
      el.focus();
      el.click();
      // Remove the temp element
      document.body.removeChild(tempEl);
    }, timeout);
  }
}

export { focusAndOpenKeyboard };
